import React, {useState, useEffect} from "react";
import {TestCard} from "../../components/global/VideoCard";
import {TestContext} from "../../context/test_context";
import {
    Avatar,
    Badge,
    Box,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    Icon,
    IconButton,
    Input,
    Pagination,
    Stack,
    TextField,
    Typography,
    debounce,
    alpha,
    Button,
} from "@mui/material";
import "../tests/styles.css";
import useAuth from "../../hooks/auth_hook";
import {useNavigate} from "react-router-dom";
import LoadBox from "../../components/global/LoadBox";
import moment from "moment";
import {ArrowBack, Close, Refresh} from "@mui/icons-material";
import TestButtonSet from "../../components/test/TestButtonSet";
import {TestList} from "../tests";

export default function CurrentTests(): any {
    return (
        <Box
            sx={{
                width: "100%",
                display: {xs: "block", md: "flex"},
                justifyContent: "center",
                marginX: 5,
                flexDirection: "row",
                pt: 2,
                maxheight: "100%",
            }}
        >
            <TestList finished={false} active={true} title={"Ongoing Tests"}/>

            <TestList finished={false} active={false} title={"Paused Tests"}/>
        </Box>
    );
}